<template>
  <v-container class="mt-0">
    <v-layout row wrap justify-center class="mt-3">
      <v-flex xs12 class="text-xs-center">
        <h1>Alerts</h1>
      </v-flex>
      <v-flex xs12 sm10 md8>
        <v-card class="info" v-for="(item, index) in alerts" v-bind:key="`item-${index}`">
          <v-list>
              <v-list-tile icon>
                <v-list-tile-avatar>
                  <v-icon left>alert_on</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.alertName">{{item}}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <template v-if="userIsCreator(index)">
                    <app-edit-alert-dialog :alert="alert(index)"></app-edit-alert-dialog>
                  </template>                  
                </v-list-tile-action>
                <v-list-tile-action>
                  <v-btn icon @click="onDeleteAlert(item)">
                    <v-icon class="grey--text text--lighten-1">delete</v-icon>
                  </v-btn>
                </v-list-tile-action>
                <v-list-tile-action>
                  <v-btn icon ripple :to="'/alerts/' + item.alertId">
                    <v-icon v-bind:color="item.active ? 'primary' : 'grey'">navigate_next</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
          </v-list>          
        </v-card>      
      </v-flex>
    </v-layout>	
  </v-container>
</template>

<script>
export default {
  props: ['id'],
  data () {
    return {
    }
  },
  computed: {
    alerts () {
      return this.$store.getters.loadedAlerts
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  methods: {
    alert (index) {
      console.log('CURRENT ITEM: ' + this.$store.getters.loadedAlert(this.alerts[index].alertId))
      return this.$store.getters.loadedAlert(this.alerts[index].alertId)
    },
    userIsCreator (index) {
      console.dir('THIS: ' + this.alerts[index].creatorId)
      var holder = this.alerts[index].creatorId
      var holder2 = this.$store.getters.user.id
      if (!this.userIsAuthenticated) {
        return false
      }
      return holder2 === holder
    },
    onDeleteAlert (alert) {
      console.log('Delete this: ' + JSON.stringify(alert))
      this.$store.dispatch('deleteAlertData', alert)
      this.$router.push('/alerts')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Alerts.vue?1f67f974